<template>
  <el-dialog title="增加积分" :visible.sync="visible" width="500px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="用户昵称">
        <el-input v-model="user.nickname" disabled />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="user.phone" disabled />
      </el-form-item>
      <el-form-item label="当前积分">
        <el-input v-model="user.points" disabled>
          <template slot="append">分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="增加积分" prop="points">
        <el-input-number
          v-model="form.points"
          :min="1"
          :max="100000"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399;">请输入要增加的积分数值</span>
      </el-form-item>
      <el-form-item label="原因" prop="reason">
        <el-input
          v-model="form.reason"
          type="textarea"
          :rows="3"
          placeholder="请输入增加积分的原因"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addPoints } from '@/api/user'

export default {
  name: 'AddPointsDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      user: {},
      form: {
        user_id: 0,
        points: 0,
        reason: ''
      },
      rules: {
        points: [
          { required: true, message: '请输入积分数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '积分必须大于0', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入增加积分的原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(user) {
      this.user = { ...user }
      this.form.user_id = user.id
      this.form.points = 0
      this.form.reason = ''
      this.visible = true
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitting = true
          try {
            const res = await addPoints(this.form)
            if (res.code === 200) {
              this.$message.success('增加成功')
              this.visible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg || '增加失败')
            }
          } catch (error) {
            this.$message.error(error.message || '增加失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
:deep(.el-input-number) {
  width: 100%;
}
</style>
